import React from 'react';
import { Outlet } from 'react-router-dom';
import Box from '@mui/material/Box';

const AuthLayout: React.FC = () => (
  <Box
    sx={{
      minHeight: '100vh',
      width: '100vw',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      // background:
      //   'linear-gradient(120deg, #b33771 0%, #8f3aff 50%, #009efd 100%)',
      backgroundColor:"whitesmoke",
      position: 'fixed',
      top: 0,
      left: 0,
      zIndex: -1,
    }}
  >
    <Box
      sx={{
        position: 'relative',
        zIndex: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        width: '100vw',
      }}
    >
      <Outlet />
    </Box>
  </Box>
);

export default AuthLayout;
